import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=2d5aa058&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"
import style0 from "./Incident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5aa058')) {
      api.createRecord('2d5aa058', component.options)
    } else {
      api.reload('2d5aa058', component.options)
    }
    module.hot.accept("./Incident.vue?vue&type=template&id=2d5aa058&", function () {
      api.rerender('2d5aa058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/tabs/Incident.vue"
export default component.exports